import { Button, Flex, Heading, useBoolean } from '@chakra-ui/react'
import type { InsuranceParamsPagedQuery } from 'BrokerTsLib/src/dtos'
import { createContext, useEffect, useState } from 'react'

import type { IPaginationContext } from 'BrokerTsLib/src/interfaces/Pagination/Pagination'
import { Container } from '../../components/Container'
import { Section } from '../../components/Section'
import { ConceptsList } from '../../containers/concepts'
import { PageContent } from '../../containers/PageContent'
import { PageToolbar } from '../../containers/PageToolbar'
import { ConceptsTravelSearch } from '../../containers/search/cestovko/ConceptsTravelSearch'
import { SearchButton } from '../../containers/search/SearchButton'
import { useGetAll } from '../../hooks/useInsuranceParams'
import { Select } from '../../icons'

export const conceptsTravelContext = createContext<IPaginationContext<InsuranceParamsPagedQuery>>({} as IPaginationContext<InsuranceParamsPagedQuery>)

export const ConceptsCestovkoPage = () => {
  const [isOpen, setOpen] = useBoolean(false)
  const [allowSelect, setAllowSelect] = useBoolean(false)

  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [deletedCounter, setDeletedCounter] = useState(0)
  const [filter, setFilter] = useState<InsuranceParamsPagedQuery>({
    //dateCreatedFrom: defaultDateFrom,
    listType: 1,
    pageIndex: 1,
  })

  const { data, mutateAsync: getAllAsync, isPending: isLoading } = useGetAll()
  const items = data?.data

  const reloadData = () => setDeletedCounter(deletedCounter + 1)

  useEffect(() => {
    setFilter({ ...filter, pageSize: pageSize, pageIndex: currentPage })
  }, [pageSize, currentPage])

  useEffect(() => {
    if (filter.pageSize) // nechci spoustet nacitani na pageload 2x
      getAllAsync(filter)
  }, [filter, deletedCounter])


  return (
    <Section>
      <Container>
        <PageContent>
          <conceptsTravelContext.Provider value={
            {
              loading: isLoading,
              totalCount: items?.totalCount ?? 0,
              currentPage: currentPage,
              pageSize: pageSize,
              filter: filter,
              setCurrentPage: setCurrentPage,
              setPageSize: setPageSize,
              updateFilter: f => setFilter(f),
              reload: reloadData
            }
          }>
            <PageToolbar
              leftElements={
                <Flex sx={{ gap: 4, alignItems: 'center' }}>
                  <Heading as="h1">Rozpracované nabídky</Heading>
                </Flex>
              }
              rightElements={
                <Flex sx={{ gap: 4 }}>
                  <Button variant="ghost" onClick={setAllowSelect.toggle}>
                    <Select color="secondary.500" />
                    Vybrat ke smazání
                  </Button>
                  <SearchButton isOpen={isOpen} setOpen={setOpen} />
                </Flex>
              }
            />

            {isOpen && <ConceptsTravelSearch />}

            <ConceptsList concepts={items?.items ?? []} withPaginator allowSelect={allowSelect} />
          </conceptsTravelContext.Provider>
        </PageContent>
      </Container>
    </Section>
  )
}
